document.addEventListener('DOMContentLoaded', function () {
  const countdownWrapper = document.querySelector('.countdown-timer-wrapper');

  if (!countdownWrapper) return;

  const endDate = countdownWrapper.getAttribute('data-end-date');
  const endTime = countdownWrapper.getAttribute('data-end-time');

  if (!endDate || !endTime) return;

  const endDateTime = new Date(`${endDate}T${endTime}`).getTime();

  function updateCountdown() {
    const now = new Date().getTime();
    const distance = endDateTime - now;

    if (distance <= 0) {
      countdownWrapper.style.display = "none";

      const countdownSection = countdownWrapper.closest('.countdown__section');
      if (countdownSection) {
        countdownSection.style.display = "none";
      }

      const limitedTimeOffer = countdownWrapper.closest('.limited-time-offer');
      if (limitedTimeOffer) {
        limitedTimeOffer.style.display = "none";
      }

      clearInterval(timerInterval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    countdownWrapper.querySelector('.countdown-days').textContent = days.toString().padStart(2, '0');
    countdownWrapper.querySelector('.countdown-hours').textContent = hours.toString().padStart(2, '0');
    countdownWrapper.querySelector('.countdown-minutes').textContent = minutes.toString().padStart(2, '0');
    countdownWrapper.querySelector('.countdown-seconds').textContent = seconds.toString().padStart(2, '0');
  }

  const timerInterval = setInterval(updateCountdown, 1000);
  updateCountdown();
});
